import styled from 'styled-components';

export const CreatePasswordDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
